import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import { auditLogSlice, AuditLogState, toggleIsAuditLogFiltersSidebarOpenAction } from './auditLog.slice';

export const auditLogMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const auditLogState = api.getState()?.[auditLogSlice.name];

  if (auditLogState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    auditLogMiddlewares[action?.type]?.(auditLogState, action);
  }

  return result;
};

const auditLogMiddlewares = {
  [toggleIsAuditLogFiltersSidebarOpenAction.type]: (state: AuditLogState) => {
    appStorage.setIsAuditLogFiltersSidebarOpen(state.isAuditLogFiltersSidebarOpen);
  },
};
